import { formatEther } from '@ethersproject/units'
import { Settings } from '../providers'
import { GasPrice } from './getGasPriceDisplay'

export function getExecutionGasPrepayDisplay(gasLimit: number, settings: Settings, gasPrice?: GasPrice) {
  if (gasPrice && gasPrice.delayGasPrice) {
    const safeGasLimit = gasLimit + settings.gasLimitOverpay
    const safeGasPrice = gasPrice.delayGasPrice.mul(settings.gasPriceMultiplier).div(1000)
    const executionGasPrepay = safeGasPrice.mul(safeGasLimit)
    return `${formatEther(executionGasPrepay)} ETH`
  }
  return '-'
}
